import React from 'react';

import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function DisableLinkModal({ onClose, onSubmit }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'projectActivity.components.DisableLinkModal',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            {i18nTShared('cancel')}
          </TextButton>
          <FilledButton color='red' onClick={onSubmit}>
            {i18nT('confirm')}
          </FilledButton>
        </div>
      }
      isOpen={true}
      mode='letterbox'
      onClose={onClose}
      usingStandardDimensions={true}
    >
      <div className='modalbox-header tw-border-grey-100'>
        <h2 className='modalbox-header__title truncated-text-container tw-text-xl tw-font-semibold tw-tracking-tight tw-text-grey-900'>
          {i18nT('title')}
        </h2>
      </div>
      <div className='modalbox-body'>{i18nT('description')}</div>
    </ModalBox>
  );
}
